import { GraphQLClient } from 'graphql-request'
import { getKcToken } from './query-client'
import { getKeycloak } from '@tecsinapse-org/portal-menu-kit'

export const client = new GraphQLClient(
  `${import.meta.env.VITE_API_URL}/api/graphql`
)

export const request = async <T, V extends object = Record<string, never>>(
  request: string,
  options?: { variables?: V }
) => {
  const keycloak = getKeycloak()

  const auth = await getKcToken(keycloak)

  const requestHeaders: Record<string, string> = {
    'Content-Type': 'application/json'
  }

  if (auth) {
    requestHeaders['Authorization'] = auth
  }

  return client.request<T>(request, options?.variables, requestHeaders)
}
